import { S3 } from "@aws-sdk/client-s3";

const s3Client = new S3({
  forcePathStyle: false, // Configures to use subdomain/virtual calling format.
  endpoint: "https://sfo3.digitaloceanspaces.com",
  region: "us-east-1",
  credentials: {
    accessKeyId: process.env.REACT_APP_SPACES_KEY || "",
    secretAccessKey: process.env.REACT_APP_SPACES_SECRET || "",
  },
});

export { s3Client };
